import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import { Clear } from "@material-ui/icons";

const CustomDatePicker = ({
  onConfirm = null,
  value = { from: "", to: "" },
}) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState({ from: "", to: "" });
  const [buttonLabel, setButtonLabel] = useState("Select Date Range");

  const handleDateChange = (name, value) => {
    setDate((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleOpen = () => {
    setOpen(true);
    setDate(value);
  };
  const handleClose = () => setOpen(false);

  const handleConfirm = () => {
    setButtonLabel(`${date?.from} / ${date?.to}`);
    onConfirm(date);
    handleClose();
  };

  const handleClear = () => {
    setDate({ from: "", to: "" });
    setButtonLabel("Select Date Range");
    onConfirm({ from: "", to: "" });
  };

  return (
    <div>
      <ButtonGroup variant="outlined">
        <Button onClick={handleOpen}>{buttonLabel}</Button>
        {buttonLabel !== "Select Date Range" && (
          <Button onClick={handleClear}>
            <Clear />
          </Button>
        )}
      </ButtonGroup>
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Select Date Range</DialogTitle>
        <DialogContent>
          <Grid container alignItems="center" justifyContent="center">
            <Grid item xs={5}>
              <TextField
                label="From Date"
                type="date"
                fullWidth
                value={date?.from}
                onChange={(e) => handleDateChange("from", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={2} container justifyContent="center">
              <Typography variant="h6">/</Typography>
            </Grid>
            <Grid item xs={5}>
              <TextField
                label="To Date"
                type="date"
                fullWidth
                value={date?.to}
                onChange={(e) => handleDateChange("to", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleConfirm}>Accept</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CustomDatePicker;
